import { environment } from "../../../environments/environment";
import { Attachment } from "../http/attachments/attachments.interface";

export class AttachmentUtil {
    public static mapPatchFileToObject(patch: string): Attachment {
        const patchObject = JSON.parse(patch);
        const attachment: Attachment = {
            name: patchObject.name,
            description: patchObject.description,
            mime: patchObject.mime,
            data: patchObject.data
        };
        return attachment;
    }

    // ArrayBuffer to base64
    public static async arrayBufferToString(asyncBuffer: Promise<ArrayBuffer>): Promise<string> {
        const buffer = await asyncBuffer;
        const bytes = new Uint8Array(buffer);
        let binary = '';
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    // https://zbe.cat:8002/zbe/exceptions/registration/applicant/exception/attachment/file?applicant=00000000T&vehicle=0000AAA&exception=24070aba-3494-4375-be5a-ee753d6de656&attachment=c7081049-d1dc-45a7-a8b1-876992c70e6a&language=es-ES
    public static getDirectLink(applicant: string, plate: string, exception: string, fileId: string): string {
        return environment.apiPublicUrl + '/registration/applicant/exception/attachment/file?applicant=' + applicant + '&vehicle=' + plate + '&exception=' + exception + '&attachment=' + fileId + '&language=es-ES';
    }

    public static getDirectLinkPrivate(applicant: string, plate: string, exception: string, fileId: string): string {
        return environment.apiPrivateUrl + '/registration/applicant/exception/attachment/file/private?applicant=' + applicant + '&vehicle=' + plate + '&exception=' + exception + '&attachment=' + fileId + '&language=es-ES';
    }

    public static getDirectLinkContactPrivate(contactId: string, fileId: string): string {
        return environment.apiPrivateUrl + '/contact/attachment?contact='+contactId+'&attachment=' + fileId + '&language=es-ES';
    }
}